import React, {Component, Fragment} from "react"
import {Link} from "react-router-dom"
import shop from "shop/shop"
import {observer} from "mobx-react"
import {reaction} from "mobx"
import {Button, Icon, Popup, Message} from "semantic-ui-react"
import Spinner                              from "components/Spinner/Spinner"
import Price from "components/Price/Price"
import MinOrderValue from "components/Cart/MinOrderValue"
import queryString from "qs"
import htmr                                                                           from "htmr";

@observer
export default class DeliveryMessage extends Component {

	constructor() {
		super()
		this.state = {
			sum: 0,
      deliverMessage: "",
      tourData: {},
      loadingDeliveryDelivery: true,
      loadCart: true
		}
	}
    componentDidMount() {
      this.getTourData();

    }
    
    getTourData = async () => {
      this.setState({ loadingDelivery: true });
      //console.log("shopping cart deliver", shop.cart)
      this.setState({ deliverMessage: shop.cart.data.extras.deliveryMessage });
      this.setState({ loadingDelivery: false });
    }

	render() {
    const { deliverMessage, loadingDelivery, loadCart } = this.state;
    const { loading } = shop.cart
    //console.log("shopping cart deliver", deliverMessage)


    if(loadingDelivery || loading) {
      this.getTourData();
      return <div className="pa4 tc">
        <Spinner size="md" type="inverted"/></div>
    }
		return (
            <Fragment>
            {deliverMessage && deliverMessage != ""  && <section className="container pt3 pb3">
                <div className="row-title tl">
                  <h2>{translate( "Unsere Mitteilung" )}</h2>
                </div>
                <div>
                  <Message>
                    <p>{htmr(deliverMessage)}</p>
                  </Message>
                </div>
                </section>}
                </Fragment>
		)
	}
}




// WEBPACK FOOTER //
// ./src/components/Cart/DeliveryMessage.js